export const VEHICLE_TYPE_MAPPER = {
  'Passenger Vehicle': 'PV',
  'Light Truck': 'LT',
  'Motorcycle': 'M',
  'Trailer': 'T',
  'Motorhome': 'O',
  'Cab & Chassis': 'CC',
  'Sports Utility Vehicle': 'SUV',
  'Multipurpose Passenger Vehicle': 'SUV',
  'Truck': 'LT',
};

export const VEHICLE_TYPE = {
  'Passenger Vehicle': 'Passenger Vehicle',
  'Pickup Truck': 'Pickup Truck',
  'Motorcycle': 'Motorcycle',
  'Sports Utility Vehicle': 'Sports Utility Vehicle',
  'Other': 'Other',
};

export const VEHICLE_TYPE_MAP = {
  'Passenger Vehicle': 'PV',
  'Pickup Truck': 'PT',
  'Motorcycle': 'M',
  'Sports Utility Vehicle': 'SUV',
  'Other': 'O',
};

export const PLATE_TYPE = {
  'Commercial': 'Commercial',
  'Regular': 'Regular',
};

export const PLATE_TYPE_MAP = {
  "C": "Commercial",
  "R": "Regular"
}

export const TRANSACTION_TYPE_MAP = {
  "Purchase": "Purchase",
  "Refinance": "Refinance"
};

export const DRIVER_CATEGORY = {
  'Business': 'Business',
  'Individual': 'Individual',
};

export const TITLE_STATUS = {
  'MSO': 'MSO (New Vehicle)',
  'T': 'Used Vehicle',
};

export const CONDITION = {
  'New': 'New',
  'Used': 'Used',
};

export const FUEL_TYPE = {
  "Gas": "Gas",
  "Electric": "Electric",
  "Diesel": "Diesel",
  "Hybrid": "Hybrid"
};

export const FUEL_TYPE_MAP = {
  "G": "Gas",
  "E": "Electric",
  "Dl": "Diesel",
  "H": "Hybrid"
};

export const BODY_STYLE = {
  "Convertible": "Convertible",
  "Coupe": "Coupe",
  "Hatchback": "Hatchback",
  "Minivan": "Minivan",
  "Passenger Sedan": "Passenger Sedan",
  "Sport Utility": "Sport Utility",
  "Sedan": "Sedan",
  "Pickup Truck": "Pickup Truck",
  "Van": "Van",
  "Truck": "Truck",
  "Motorcycle": "Motorcycle",
  "Recreational Vehicle": "Recreational Vehicle",
  "Wagon": "Wagon"
};

export const CYLINDERS = {
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "10": "10",
  "12": "12",
  "16": "16"
};

export const COLOR = {
  "Black": "Black",
  "Blue": "Blue",
  "Bronze": "Bronze",
  "Brown": "Brown",
  "Gold": "Gold",
  "Green": "Green",
  "Grey": "Grey",
  "Maroon": "Maroon",
  "Orange": "Orange",
  "Pink": "Pink",
  "Purple": "Purple",
  "Red": "Red",
  "Silver": "Silver",
  "Tan": "Tan",
  "White": "White",
  "Yellow": "Yellow"
};

export const STATE_MAPPER = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'FL': 'Florida',
  'GA': 'Georgia',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PA': 'Pennsylvania',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming'
};
